export default __webpack_public_path__ + "static/media/store-of-value.458f7b8c.png";